module.exports = __webpack_public_path__ + "media/icons/car-1-89458d90.png";